import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import utils from "./utils/utils";
import methodJs from "./utils/public";
import config from "./request/config";
import './assets/icons'  // icons
// 打印
import Print from "vue-print-nb";
Vue.use(Print);
// 引入富文本
import quillEditor from "vue-quill-editor";
// 引入样式
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
Vue.use(quillEditor /* { 默认全局 } */);
// 引入elementUI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
//引入echarts
import * as echarts from "echarts";
// 全局引入elementUI
Vue.use(ElementUI);
// 引入pdf
import vueToPdf from "vue-to-pdf";
Vue.use(vueToPdf);

import vueEsign from 'vue-esign'
Vue.use(vueEsign)

// 引入高德地图
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import selectUser from "@/components/selectUser/selectUser.vue";
Vue.component("selectUser", selectUser);
/* 图片上传 */
import uploadImg from "@/components/upload/uploadImg.vue";
Vue.component("uploadImg", uploadImg);
/* 文件上传 */
import fileUpload from "@/components/upload/fileUpload.vue";
Vue.component("fileUpload", fileUpload);
/* 地图标记 */
import position from "@/components/position/map.vue";
Vue.component("position", position);
// 文件上传组件
import FileUpload from "@/components/FileUpload/index.vue"
Vue.component('FileUpload', FileUpload)
// 图片上传组件
import ImageUpload from "@/components/ImageUpload/index.vue"
Vue.component('ImageUpload', ImageUpload)


// 挂载全局api
import http from "./request/index";
Vue.prototype.$http = http;
Vue.prototype.$utils = utils;
Vue.prototype.$config = config;
Vue.prototype.$methodJs = methodJs
Vue.config.productionTip = false;
//echarts 全局挂载
Vue.prototype.$echarts = echarts;

Vue.directive("dialogDrag", {
  bind(el, binding, vnode) {
  },
});

function queryURLParams(URL) {
  let url = URL.split('?')[1];
  const urlSearchParams = new URLSearchParams(url);
  const params = Object.fromEntries(urlSearchParams.entries());
  return params;
}

let URL = window.location.href;
let path = queryURLParams(URL).path;
if (path) {
  localStorage.setItem('path', path);
}

// 全局配置防止多次点击
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 2000)
      }
    })
  }
})

new Vue({
  router,
  store,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
